import { ActionIcon, Group } from '@mantine/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Text from '../Text/Text';
import './Stepper.scss';

type StepperProps = {
	value: number;
	min?: number;
	max?: number;
	disabled?: boolean;
	step?: number;
	onChange: ( next: number ) => void;
	'aria-label'?: string;
};

const clamp = ( value: number, min: number, max: number ) => Math.min( Math.max( value, min ), max );

const Stepper = ( {
	value,
	min = 1,
	max = Infinity,
	step = 1,
	disabled = false,
	onChange,
	'aria-label': ariaLabel = 'Quantity'
}: StepperProps ) => {
	const decrement = () => {
		const next = clamp( value - step, min, max );
		if ( next !== value ) onChange( next );
	};

	const increment = () => {
		const next = clamp( value + step, min, max );
		if ( next !== value ) onChange( next );
	};

	const canDecrement = !disabled && value > min;
	const canIncrement = !disabled && value < max;

	return (
		<Group className="Stepper" spacing="xs" aria-label={ariaLabel} noWrap>
			<ActionIcon
				className="Stepper__button"
				variant="default"
				onClick={decrement}
				disabled={!canDecrement}
				aria-label={`Decrease ${ariaLabel}`}
			>
				<RemoveIcon className="Stepper__icon" />
			</ActionIcon>
			<Text className="Stepper__value" size="md" weight={600}>
				{value}
			</Text>
			<ActionIcon
				className="Stepper__button"
				variant="default"
				onClick={increment}
				disabled={!canIncrement}
				aria-label={`Increase ${ariaLabel}`}
			>
				<AddIcon className="Stepper__icon" />
			</ActionIcon>
		</Group>
	);
};

export default Stepper;
